import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import Input from 'components/_parts/atoms/input';
import TextEditor from 'components/_parts/atoms/textEditor';

import 'components/company/revamp/parts/setting/customWla/list/index.scss';
import { useContext, useState } from 'react';
import './index.scss';
import { Hooks } from 'providers';
import { useSelector } from 'react-redux';
import { useCompetencyMoveMutation, useSubSkillGroupMultipleMutation } from 'components/company/hooks/useCompany';
import LoadingCustom from 'components/layouts/loading/loading';
import customHooks from './customHooks';
import initialValues from './initialValues';

function CollapsibleEdit(props) {
  const {
    data, formik, t, typeForm, setInitialValuesMod, tab,
  } = props;
  const competencyMoveMutation = useCompetencyMoveMutation();
  const subSkillGroupMultipleMutation = useSubSkillGroupMultipleMutation();
  const { setShowInfoComp, setDataInfoComp } = useContext(Hooks);
  const [activeCollapsible, setActiveCollapsible] = useState(null);
  const [isOpen, setIsOpen] = useState(null);
  const {
    keyListComp,
    listSkillGroup,
    keyListSkillGroup,
    keySubSkillGroup,
    keyMultipleSubSkillGroup,
    sub_skill_group_list_multiple,
  } = useSelector((state) => ({
    keyListComp: state?.loading?.listKey?.companyLibray,
    keyListSkillGroup: state?.loading?.listKey?.list_skill_group,
    keySubSkillGroup: state?.loading?.listKey?.list_sub_skill_group,
    keyMultipleSubSkillGroup:
      state?.loading?.listKey?.list_multiple_sub_skill_group,
    listSkillGroup: state?.company?.skill_group_list
      .filter((val) => val.status === 'active')
      .map((val) => ({
        value: val.competency_skill_group_id,
        label: val.skill_group_name,
      })),
    listSubSkillGroup: state?.company?.sub_skill_group_list
      ?.filter((val) => val.status === 'active')
      .map((val) => ({
        value: val.competency_sub_skill_group_id,
        label: val.sub_skill_group_name,
      })),
    sub_skill_group_list_multiple: state?.company?.sub_skill_group_list_multiple,
  }));

  const { handleAddLevel, handleDelLevel, emptyEvent } = customHooks({
    initialValues,
  });

  const handleCollapse = (category) => {
    if (activeCollapsible === category) {
      setActiveCollapsible(null);
    } else {
      setActiveCollapsible(category);
    }
  };

  const handleDelete = (ix) => {
    const updatedData = data.competency_detail.filter(
      (item, index) => index !== ix,
    );
    formik.setFieldValue('data.competency_detail', updatedData);
    setInitialValuesMod((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        competency_detail: updatedData,
      },
    }));
  };

  const handleAddSubSkill = (ix) => {
    const newData = [...data.competency_detail];
    const dataAdd = {
      competency_type: '',
      description_sub_skill: '',
      detail: [
        { ...initialValues.tempData.competency_detail[0].detail[0], order: 1 },
      ],
    };
    newData.splice(ix + 1, 0, dataAdd);

    formik.setFieldValue('data.competency_detail', newData);
  };

  const handleMoveComp = (compId, typeVal) => {
    const companyId = localStorage.getItem('company_id');

    competencyMoveMutation.mutate({
      payloadList: { company_id: companyId, type: tab, status: 'active' },
      payloadMove: { competency_detail_id: compId, type: typeVal },
    });
  };

  const isTechnical = tab === 'technical_competency';
  const isFunctional = tab === 'functional_competency';

  return keyListSkillGroup && keySubSkillGroup ? (
    <LoadingCustom />
  ) : (
    data?.competency_detail?.map((vx, ix) => (
      <div
        key={vx.competency_type + ix}
        className="custom_wla-collapsible-container"
        style={{ margin: '10px 0px' }}
      >
        <div className="competency_lib_edit">
          <div className="d-flex justify-content-between mb-2" style={{ gap: '10px' }}>
            <div
              className={`${isFunctional || isTechnical ? '' : 'd-none'}`}
              style={{ width: '50%' }}
            >
              <Input
                id="compLibrary-skillGroup"
                type="dropdown-windowed"
                value={listSkillGroup?.filter((val) => formik.values.data?.competency_detail?.[
                  ix
                ]?.competency_group?.includes(val.value))}
                maxwidth="inherit"
                placeholder={t('company.ins_skill_group_name')}
                name={`data.competency_detail.[${ix}].competency_group`}
                options={keyListSkillGroup ? [] : listSkillGroup}
                onChange={(e) => {
                  formik.setFieldValue(
                    `data.competency_detail.[${ix}].competency_group`,
                    e?.value,
                  );
                  subSkillGroupMultipleMutation.mutate({
                    index: ix,
                    payload: {
                      competency_skill_group_id: e?.value,
                    },
                  });
                }}
                noOptionsMessage={() => (keyListSkillGroup
                  ? 'Loading Get Data...'
                  : t('org.structure_view.personel.form.p_option'))}
                isError={
                      formik.errors.data?.competency_detail?.[ix]
                        ?.competency_group
                    }
                validateMessage={
                      formik.errors.data?.competency_detail?.[ix]
                        ?.competency_group
                    }
              />
            </div>
            <div style={{ width: '50%' }}>
              <Input
                id="compLibrary-subSkillGroup"
                type="dropdown-windowed"
                value={sub_skill_group_list_multiple[ix]?.filter((val) => formik.values.data?.competency_detail?.[
                  ix
                ]?.competency_type?.includes(val.value))}
                maxwidth="inherit"
                placeholder={t('company.ins_sub_name')}
                name={`data.competency_detail.[${ix}].competency_type`}
                options={
                      keyMultipleSubSkillGroup
                        ? []
                        : sub_skill_group_list_multiple[ix]
                    }
                onChange={(e) => {
                  formik.setFieldValue(
                    `data.competency_detail.[${ix}].competency_type`,
                    e?.value,
                  );
                }}
                noOptionsMessage={() => (keyMultipleSubSkillGroup
                  ? 'Loading Get Data...'
                  : t('org.structure_view.personel.form.p_option'))}
                isError={
                      formik.errors.data?.competency_detail?.[ix]
                        ?.competency_type
                    }
                validateMessage={
                      formik.errors.data?.competency_detail?.[ix]
                        ?.competency_type
                    }
              />
            </div>
          </div>
          <div style={{ width: '100%' }}>
            <Label typeLabel="label_option">
              {t('company.competency_desc')}
            </Label>
            <TextEditor
              id="text-editor-output"
              name={`data.competency_detail.[${ix}].description_sub_skill`}
              placeholder={t('company.ins_desc')}
              style={{ height: '130px', margin: '5px 0px 2px 0px' }}
              value={vx.description_sub_skill || ''}
              onChange={(e) => {
                const value = emptyEvent(e);
                formik.setFieldValue(
                  `data.competency_detail.[${ix}].description_sub_skill`,
                  value,
                );
              }}
            />
            {formik.errors.data?.competency_detail?.[ix]
              ?.description_sub_skill ? (
                <span className="error_form m-0">
                  {
                        formik.errors.data?.competency_detail?.[ix]
                          ?.description_sub_skill
                      }
                </span>
              ) : null}
          </div>
        </div>
        <div className="collapsible_lib scrollCustom">
          {vx?.detail?.map((v, i) => (
            <div
              key={v.competency_detail_id}
              className={`${
                typeForm === 'create'
                  ? 'collapsible_lib-listCollapse'
                  : 'collapsible_lib-listCollapseEdit'
              }`}
            >

              {typeForm === 'edit'
                    && (keyListComp ? (
                      <div>
                        <LoadingCustom />
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-between w-100">
                          <div style={{ width: '30%' }}>
                            <Input
                              type="text"
                              value={v.competency_level}
                              maxwidth="inherit"
                              placeholder={t('company.lvl_name')}
                              name={`data.competency_detail[${ix}].detail[${i}].competency_level`}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `data.competency_detail[${ix}].detail[${i}].competency_level`,
                                  e.target.value,
                                );
                              }}
                              isError={
                                formik.errors.data?.competency_detail?.[ix]
                                  ?.detail?.[i]?.competency_level
                              }
                              validateMessage={
                                formik.errors.data?.competency_detail?.[ix]
                                  ?.detail?.[i]?.competency_level
                              }
                            />
                          </div>
                          <div
                            className="d-flex align-items-center"
                            style={{ padding: '2px 0px', gap: '4px' }}
                          >
                            <div
                              className="d-flex"
                              style={{ marginRight: '20px', gap: '5px' }}
                            >
                              <Button
                                className={`${i === 0 ? 'd-none' : ''}`}
                                icon="next"
                                style={{ height: '25px', width: '26px' }}
                                func={() => handleMoveComp(
                                  v.competency_detail_id,
                                  'move_up',
                                )}
                              />
                              <Button
                                className={`${
                                  vx?.detail?.length - 1 === i ? 'd-none' : ' '
                                }`}
                                icon="prev"
                                style={{ height: '25px', width: '26px' }}
                                func={() => handleMoveComp(
                                  v.competency_detail_id,
                                  'move_down',
                                )}
                              />
                            </div>
                            <Button
                              icon="minus"
                              style={{
                                height: '25px',
                                width: '26px',
                                backgroundColor: '#FF4F4F',
                              }}
                              func={() => handleDelLevel({
                                detailId: v.competency_detail_id,
                                ix,
                                data,
                                setFieldValue: formik.setFieldValue,
                              })}
                            />
                            <Button
                              icon="create"
                              style={{
                                height: '24px',
                                width: '26px',
                                backgroundColor: '#9AFF5B',
                                visibility:
                                  i === vx?.detail?.length - 1 ? '' : 'hidden',
                              }}
                              func={() => handleAddLevel({
                                dataDetail: vx?.detail,
                                ix,
                                i,
                                setFieldValue: formik.setFieldValue,
                                setIsOpen,
                              })}
                            />
                            <Button
                              icon={`${isOpen === i ? 'down' : 'chevronRight'}`}
                              style={{
                                height: '24px',
                                width: '26px',
                                backgroundColor: 'white',
                                color: '#4C4C4C',
                              }}
                              func={() => (isOpen === i ? setIsOpen(null) : setIsOpen(i))}
                            />
                          </div>
                        </div>

                        {isOpen === i && (
                          <>
                            {/* HIDDEN LEVEL DESC */}
                            {/* <div className="w-50 mt-2 mb-4">
                                <Label typeLabel="label_option">
                                  {t('company.level_desc')}
                                </Label>
                                <Input
                                  type="text"
                                  value={v.value}
                                  maxwidth="inherit"
                                  placeholder={t('company.ins_desc_')}
                                  placeholderPosition="start"
                                  name={`data.competency_detail[${ix}].detail[${i}].value`}
                                  onChange={(e) => {
                                    formik.setFieldValue(`data.competency_detail[${ix}].detail[${i}].value`, e.target.value);
                                  }}
                                />
                              </div> */}

                            <div
                              className="w-100 h-100 mt-4 px-2 d-flex"
                              style={{ gap: '15px', flexWrap: 'wrap' }}
                            >
                              <div style={{ width: '49%' }}>
                                <Label typeLabel="label_option">
                                  {t(
                                    isTechnical
                                      ? 'company.perform_crit'
                                      : 'company.behaviour_indicator',
                                  )}
                                </Label>
                                <TextEditor
                                  id="text-editor-output"
                                  name={`data.competency_detail[${ix}].detail[${i}].performance_criteria`}
                                  placeholder={t('company.ins_desc_')}
                                  style={{
                                    height: '130px',
                                    margin: '5px 0px 2px 0px',
                                  }}
                                  value={v.performance_criteria || ''}
                                  onChange={(e) => {
                                    const value = emptyEvent(e);
                                    formik.setFieldValue(
                                      `data.competency_detail[${ix}].detail[${i}].performance_criteria`,
                                      value,
                                    );
                                  }}
                                />
                                {formik.errors?.data?.competency_detail?.[ix]
                                  ?.detail?.[i]?.performance_criteria ? (
                                    <span className="error_form m-0">
                                      {
                                      formik.errors?.data?.competency_detail?.[
                                        ix
                                      ]?.detail?.[i]?.performance_criteria
                                    }
                                    </span>
                                  ) : null}
                              </div>
                              <div style={{ width: '49%' }}>
                                <Label typeLabel="label_option">
                                  {t('company.field_skill_exp')}
                                </Label>
                                <TextEditor
                                  id="text-editor-output"
                                  name={`data.competency_detail${[
                                    ix,
                                  ]}.detail[${i}].experience`}
                                  placeholder={t('company.ins_desc_')}
                                  style={{
                                    height: '130px',
                                    margin: '5px 0px 2px 0px',
                                  }}
                                  value={v.experience || ''}
                                  onChange={(e) => {
                                    const value = emptyEvent(e);
                                    formik.setFieldValue(
                                      `data.competency_detail[${ix}].detail[${i}].experience`,
                                      value,
                                    );
                                  }}
                                />
                                {formik.errors.data?.competency_detail?.[ix]
                                  ?.detail?.[i]?.experience ? (
                                    <span className="error_form mx-0">
                                      {
                                      formik.errors.data?.competency_detail?.[
                                        ix
                                      ]?.detail?.[i]?.experience
                                    }
                                    </span>
                                  ) : null}
                              </div>
                              <div style={{ width: '49%' }}>
                                <Label typeLabel="label_option">
                                  {t('company.learning_development')}
                                </Label>
                                <TextEditor
                                  id="text-editor-output"
                                  name={`data.competency_detail[${ix}].detail[${i}].learning_development`}
                                  placeholder={t('company.ins_desc_')}
                                  style={{
                                    height: '130px',
                                    margin: '5px 0px 2px 0px',
                                  }}
                                  value={v?.learning_development || ''}
                                  onChange={(e) => {
                                    const value = emptyEvent(e);
                                    formik.setFieldValue(
                                      `data.competency_detail[${ix}].detail[${i}].learning_development`,
                                      value,
                                    );
                                  }}
                                />
                                {formik.errors.data?.competency_detail?.[ix]
                                  ?.detail?.[i]?.learning_development ? (
                                    <span className="error_form mx-0">
                                      {
                                      formik.errors.data?.competency_detail?.[
                                        ix
                                      ]?.detail?.[i]?.learning_development
                                    }
                                    </span>
                                  ) : null}
                              </div>
                              <div style={{ width: '49%' }}>
                                <Label typeLabel="label_option">
                                  {t('company.evidence')}
                                </Label>
                                <TextEditor
                                  id="text-editor-output"
                                  name={`data.competency_detail[${ix}].detail[${i}].evidence`}
                                  placeholder={t('company.ins_desc_')}
                                  style={{
                                    height: '130px',
                                    margin: '5px 0px 2px 0px',
                                  }}
                                  value={v?.evidence || ''}
                                  onChange={(e) => {
                                    const value = emptyEvent(e);
                                    formik.setFieldValue(
                                      `data.competency_detail[${ix}].detail[${i}].evidence`,
                                      value,
                                    );
                                  }}
                                />
                                {formik.errors.data?.competency_detail?.[ix]
                                  ?.detail?.[i]?.evidence ? (
                                    <span className="error_form mx-0">
                                      {
                                      formik.errors.data?.competency_detail?.[
                                        ix
                                      ]?.detail?.[i]?.evidence
                                    }
                                    </span>
                                  ) : null}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
            </div>
          ))}
        </div>
      </div>
    ))
  );
}

export default CollapsibleEdit;
